import Search from './search';

export default class Header {
    constructor($header) {
        this.$header = $header;
        this.$menuwrapper = this.$header.querySelector('[data-menu-wrapper]');
        this.$menu = this.$header.querySelector('[data-menu]');
        this.$openMenu = this.$header.querySelector('[data-open-menu]');
        this.$closeMenu = this.$header.querySelector('[data-close-menu]');
        this.checkHeader = this.checkHeader.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.$openSubMenu = this.$header.querySelectorAll('[data-open-sub-menu]');
        this.$closeSubMenu = this.$header.querySelectorAll('[data-close-sub-menu]')
        this.openSubMenu = this.openSubMenu.bind(this);
        this.closeSubMenu = this.closeSubMenu.bind(this);

        window.addEventListener('scroll', this.checkHeader);
        this.$openMenu?.addEventListener('click', this.openMenu);
        this.$closeMenu?.addEventListener('click', this.closeMenu);
        this.$openSubMenu.forEach($item => $item.addEventListener('click', this.openSubMenu));
        this.$closeSubMenu.forEach($item => $item.addEventListener('click', this.closeSubMenu));
        this.$menuwrapper?.addEventListener('click', (e) => {
            const isClickInside = this.$menu.contains(e.target);

            if (!isClickInside) {
                this.closeMenu(e);
            }
        });

        this.checkHeader();

        this.search = (new Search(this.$header));
    }

    checkHeader() {
        let scrollPosition = window.pageYOffset;

        if (scrollPosition > 30) {
            this.$header.classList.add('header--sticky');
        } else {
            this.$header.classList.remove('header--sticky');
        }

        if (scrollPosition > 100) {
            this.$header.classList.add('header--hidden');
        } else {
            this.$header.classList.remove('header--hidden');
        }

        if(this.lastScrollPosition > scrollPosition) {
            this.$header.classList.remove('header--hidden');
        }

        this.lastScrollPosition = scrollPosition;
    }

    openMenu(e) {
        e.preventDefault();
        this.$menuwrapper.classList.add('header__mobile-wrapper--open');
        document.querySelector('.wrapper').classList.add('menu-active');
        document.querySelector('body').classList.add('no-scroll');
    }

    closeMenu(e) {
        e.preventDefault();
        this.$menuwrapper.classList.remove('header__mobile-wrapper--open');
        this.$header.querySelectorAll('[data-sub-menu]').forEach($item => $item.classList.remove('subheader-menu--open'));
        document.querySelector('.wrapper').classList.remove('menu-active');
        document.querySelector('body').classList.remove('no-scroll');
    }

    openSubMenu(e) {
        if(window.innerWidth > 992) {
            return;
        }

        e.preventDefault();
        const menuId = e.target.dataset.openSubMenu;
        const $menu = this.$header.querySelector('[data-sub-menu="' + menuId +'"]');
        $menu.classList.add('subheader-menu--open');
    }

    closeSubMenu(e) {
        if(window.innerWidth > 992) {
            return;
        }

        e.preventDefault();
        const menuId = e.target.dataset.closeSubMenu;
        const $menu = this.$header.querySelector('[data-sub-menu="' + menuId +'"]');
        $menu.classList.remove('subheader-menu--open');
    }
}